import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { InnerProcedureConfig } from '@core/models/built/procedure-step-config.model';
import { InputJson } from '@core/models/built/session-step-value-json.model';
import { SessionStep } from '@core/models/session.model';
import { TranslocoService } from '@ngneat/transloco';
import { filterTruthy } from '@utils';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';

import it from './i18n/step-common-value-report.it.json';

@Component({
  selector: 'step-common-value-report',
  templateUrl: './step-common-value-report.component.html',
})
export class StepCommonValueReportComponent implements OnChanges {

  @Input() step!: SessionStep;

  private step$$ = new BehaviorSubject<SessionStep | undefined>(undefined);
  step$ = this.step$$.pipe(filterTruthy());

  inputs$ = this.step$.pipe(
    map(step => step.values?.map(v => (v.value as InputJson<string | number | Date>).input) || [])
  );

  innerProcedureId$ = this.step$.pipe(
    map(step => (step.procedureStep?.config as InnerProcedureConfig).innerProcedureId)
  );

  constructor(
    private translocoSvc: TranslocoService
  ) {
    this.translocoSvc.setTranslation(it, 'it');
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.step) {
      this.step$$.next(changes.step.currentValue);
    }
  }

}
